import React from 'react';
import { designSystem } from '@yola/ws-ui';
import PropTypes from 'prop-types';

const { Box, Stack, Heading } = designSystem;

const boxPaddings = {
  paddingTop: 'spacing-xs',
  paddingBottom: 'spacing-s',
  paddingLeft: 'spacing-m',
  paddingRight: 'spacing-m',
};

function SectionOption({ children, option }) {
  return (
    <Box {...boxPaddings}>
      <Stack gap="spacing-2-xs">
        <Heading type="heading-6" singleLine>
          {option.title}
        </Heading>
        {children}
      </Stack>
    </Box>
  );
}

SectionOption.propTypes = {
  children: PropTypes.node.isRequired,
  option: PropTypes.shape({
    id: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    options: PropTypes.array.isRequired,
  }).isRequired,
};

export default SectionOption;
